<template>
    <div>
        <div class="modal hide fade" id="modalReturNote" tabindex="-1" role="dialog" aria-labelledby="modalReturNote" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Retur Note</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label for="notes" class="col-form-label">Notes:</label>
                                <textarea rows="5" class="form-control" v-model="detailReturn.notes" :disabled="retur.lock"></textarea>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button data-dismiss="modal" class="btn btn-sm btn-primary" @click="processNotes" :disabled="retur.lock">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'PurchasingReturnNoteModal',
  props: ['detailReturn', 'retur'],
  methods: {
    processNotes () {
      this.$emit('processNotes')
    }
  }
}
</script>
